import { useEffect } from 'react';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { ConfirmPopup, LegalDocument, ScrollArea } from '~/commonComponents';
import { useToggle } from '~/hooks';
import { TnCContents } from './Constants';
import { firePermPostJobTermsAddendumViewed } from '~/posthogs/events';

interface IProps {
  isOpen: boolean;
  isLoading?: boolean;
  onConfirm: () => void;
  jobPostingId?: string;
}

export const TermsConditionAddendumPopup = ({
  isLoading = false,
  isOpen,
  onConfirm,
  jobPostingId,
}: IProps) => {
  const [isAtBottom, controls] = useToggle();

  // Track when the popup is viewed
  useEffect(() => {
    if (isOpen && jobPostingId) {
      firePermPostJobTermsAddendumViewed({ postingId: jobPostingId });
    }
  }, [isOpen, jobPostingId]);

  if (!isOpen) {
    return null;
  }

  return (
    <ConfirmPopup
      title={
        <Typography as="span" bold color={colors.primary[500]} size="heading_3">
          GoTu’s Terms Addendum for
          <br />
          Permanent Placement
        </Typography>
      }
      titleStyle={{ alignSelf: 'flex-start', textAlign: 'left' }}
      modalStyle={{
        height: 590,
        width: 544,
        paddingBlock: 48,
        paddingInline: 76,
      }}
      rightButtonAction={onConfirm}
      rightButtonDisabled={!isAtBottom}
      rightButtonLoading={isLoading}
      rightButtonStyle={{ height: 48, width: 296, marginTop: 30, alignSelf: 'center' }}
      rightButtonText={isAtBottom ? 'I Agree, Post Job' : 'Scroll to Agree'}
    >
      <ScrollArea
        style={{
          flex: 1,
          paddingRight: 14,
          width: 'auto',
        }}
        onEndReached={controls.setOn}
      >
        <LegalDocument content={TnCContents} />
      </ScrollArea>
    </ConfirmPopup>
  );
};
